import { useEffect, useContext } from "react";
import DeviceList from "./DeviceList";
import DeviceDetailCard from "./DeviceDetailCard";
// import BingMap from "./BingMap";
import LeafletMap from "./LeafletMap";
import { DeviceReducerActionType } from "../reducers/deviceReducer";
import { DeviceContext } from "../contexts/DeviceContext";
import { useAsyncGet } from "../utils/fetchUtils";
import { CONSTANT } from "../utils/constants";
import "../styles/ServiceView.css";

const ServiceView = () => {
  const { deviceDispatch } = useContext(DeviceContext);

  useEffect(() => {
    useAsyncGet(`${CONSTANT.URL.API}/${CONSTANT.API.DEVICE}`, null).then((data) => {
      data ? ( data.device ? deviceDispatch({ type: DeviceReducerActionType.UPDATE_DEVICE_LIST, payload: data.device }) : null ) : null;
    });
  }, []);

  return (
    <>
      <DeviceDetailCard />
      <DeviceList />
      <LeafletMap />
    </>
  );
};

export default ServiceView;
